import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { SERVICES } from "@/data/services";

export default function Offerings() {
  return (
    <section id="work" className="relative py-24 md:py-36" data-testid="offerings-section">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
            <div>
              <p className="eyebrow mb-6">Our Services</p>
              <h2 className="font-display text-ink font-medium leading-[1.1] text-4xl sm:text-5xl" data-testid="offerings-heading">
                Work with Rajdeep
              </h2>
            </div>
            <p className="text-inkdim text-sm max-w-xs leading-relaxed">
              Five rooms, one practice. Each begins the same way — with a conversation.
            </p>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-6 gap-5">
          {SERVICES.map((o, i) => (
            <Reveal key={o.n} delay={i * 0.06} className={i < 2 ? "lg:col-span-3" : "lg:col-span-2"}>
              <Link
                to={`/services#${o.slug}`}
                data-testid={`offering-card-${o.slug}`}
                className="group relative flex flex-col h-full bg-sand/50 border border-[rgba(169,129,47,0.26)] hover:border-gold hover:bg-sand transition-colors duration-500"
              >
                <div className="overflow-hidden">
                  <img
                    src={o.image}
                    alt={o.name}
                    loading="lazy"
                    className={`w-full object-cover group-hover:scale-[1.04] transition-transform duration-[1400ms] ease-out ${
                      i < 2 ? "h-56 md:h-64" : "h-44"
                    }`}
                    data-testid={`offering-image-${o.slug}`}
                  />
                </div>
                <div className="flex flex-col flex-1 p-7">
                  <div className="flex items-start justify-between mb-5">
                    <span className="text-[11px] tracking-[0.3em] text-gold">{o.n}</span>
                    <span className="w-2 h-2 rotate-45 border border-gold group-hover:bg-gold transition-all duration-500" aria-hidden="true" />
                  </div>
                  <h3 className="font-display text-2xl md:text-[1.6rem] text-ink mb-3 leading-snug group-hover:text-gold transition-colors duration-500">
                    {o.name}
                  </h3>
                  <p className="text-inkdim text-sm leading-relaxed">{o.tagline}</p>
                  <span className="inline-flex items-center gap-2 mt-6 text-[10px] uppercase tracking-[0.24em] text-gold group-hover:gap-3 transition-all duration-500">
                    Read more <ArrowRight size={12} strokeWidth={1.5} />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-wrap items-center gap-6">
            <Link
              to="/services"
              data-testid="offerings-all-services-link"
              className="bg-deep text-canvas text-xs uppercase tracking-[0.24em] font-semibold px-9 py-4 hover:bg-gold transition-colors duration-300"
            >
              All services &amp; fees
            </Link>
            <Link
              to="/faq"
              data-testid="offerings-faq-link"
              className="gold-underline-link text-[11px] uppercase tracking-[0.24em] text-inkdim hover:text-gold"
            >
              Important terms &amp; FAQ
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
